export default () => ({
  context       : {},
  menuTopics    : [],
  selectedTopic : {},
  viewedTopicId : 0,
  userContext   : {},
  isStudentView : false
});
